import {NgModule} from '@angular/core';
import {CommonModule} from '@angular/common';
import {I18nModule} from '../../i18n/i18n.module';
import {BigBreadcrumbsComponent} from './big-breadcrumbs.component';
import {MinifyMenuComponent} from './minify-menu.component';
import {NavigationComponent} from './navigation.component';
import {SmartMenuDirective} from './smart-menu.directive';
import {UserModule} from '../../user';
import {RouterModule} from '@angular/router';
import {CustomPipesModule} from '../../../+app-custom/pipes/customPipes.module';

@NgModule({
    imports: [
        CommonModule,
        RouterModule,
        I18nModule,
        UserModule,
        CustomPipesModule
    ],
    declarations: [
        BigBreadcrumbsComponent,
        MinifyMenuComponent,
        NavigationComponent,
        SmartMenuDirective,
    ],
    exports: [
        BigBreadcrumbsComponent,
        MinifyMenuComponent,
        NavigationComponent,
        SmartMenuDirective,
    ]
})

export class NavigationModule {

}



// WEBPACK FOOTER //
// ./src/app/shared/layout/navigation/navigation.module.ts